import React from "react";
import { CTAButton } from "./CTAButton";
type SectionCTAProps = {
  label: string;
  tone?: "light" | "dark";
};
export function SectionCTA({
  label,
  tone = "light"
}: SectionCTAProps) {
  return <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-283" data-mp="1ldmlbqr01l27">
      <CTAButton label={label} data-id="element-284" data-mp="1lexs7zfqr8xj" />
      <p className={`mt-3 text-sm ${tone === "dark" ? "text-white/70" : "text-muted"}`} data-id="element-285" data-mp="1qbenddlcynk4">
        Only <strong className={tone === "dark" ? "text-white" : "text-ink"} data-id="element-286" data-mp="1bn9zzwbd1nv0">$27 USD</strong> · Immediate digital access · 7-Day Guarantee
      </p>
    </div>;
}